import { useEffect, useState } from "react";

import { updateGeneralSettings } from "../../services/settingsApi";

function GeneralSettings({ settings, reload }) {

    const [formData, setFormData] = useState({
        appName: "",
        appTagline: "",
        defaultLanguage: "",
        timeZone: "",
        currency: "",
    });

    useEffect(() => {

        if (settings) {

            setFormData({
                appName: settings.appName || "",
                appTagline: settings.appTagline || "",
                defaultLanguage: settings.defaultLanguage || "",
                timeZone: settings.timeZone || "",
                currency: settings.currency || "",
            });

        }

    }, [settings]);

    const handleChange = (e) => {

        setFormData({
            ...formData,
            [e.target.name]: e.target.value,
        });

    };

    const handleSubmit = async (e) => {

        e.preventDefault();

        try {

            await updateGeneralSettings(formData);

            alert("General settings updated successfully.");

            reload();

        } catch (error) {

            console.error(error);

            alert("Failed to update settings.");

        }

    };

    return (

        <form
            className="settings-form"
            onSubmit={handleSubmit}
        >

            <div className="settings-card">

                <h2>General Settings</h2>

                <div className="settings-grid">

                    <div className="form-group">

                        <label>Application Name</label>

                        <input
                            type="text"
                            name="appName"
                            value={formData.appName}
                            onChange={handleChange}
                        />

                    </div>

                    <div className="form-group">

                        <label>Application Tagline</label>

                        <input
                            type="text"
                            name="appTagline"
                            value={formData.appTagline}
                            onChange={handleChange}
                        />

                    </div>

                    <div className="form-group">

                        <label>Default Language</label>

                        <input
                            type="text"
                            name="defaultLanguage"
                            value={formData.defaultLanguage}
                            onChange={handleChange}
                        />

                    </div>

                    <div className="form-group">

                        <label>Time Zone</label>

                        <input
                            type="text"
                            name="timeZone"
                            value={formData.timeZone}
                            onChange={handleChange}
                        />

                    </div>

                    <div className="form-group">

                        <label>Currency</label>

                        <input
                            type="text"
                            name="currency"
                            value={formData.currency}
                            onChange={handleChange}
                        />

                    </div>

                </div>

                <button
                    type="submit"
                    className="save-btn"
                >
                    Save General Settings
                </button>

            </div>

        </form>

    );

}

export default GeneralSettings;